import { AddressBook, Buildings, ChartBar, Coins, Files, Flag, GearSix, GridFour, Handshake, IdentificationBadge, ListChecks, ShieldCheck, UserList, Users, } from "@phosphor-icons/react";
import { Modules } from "../../../application/common/enums/screen-name";
export const isGroup = (node) => Array.isArray(node.children);
/**
 * Same items, same routes, same i18next keys and same permission gates as the
 * previous SideNavBar — only the icons changed (six near-identical Keyhole/GearSix
 * glyphs were unscannable) and the rows moved out of JSX so every state
 * (full / rail / drawer / flyout) renders from one source.
 */
export const NAV_ITEMS = [
    {
        id: "dashboard",
        label: "Dashboard",
        translated: true,
        to: "/",
        icon: GridFour,
        isActive: ({ segment }) => segment === "",
    },
    {
        id: "kpi",
        label: "KPIDashboard",
        translated: true,
        to: "/dashboard-kpi",
        icon: ChartBar,
        module: Modules.KPIDashboard,
        isActive: ({ segment }) => segment === "dashboard-kpi",
    },
    {
        id: "sale",
        label: "Sale",
        translated: true,
        to: "/leads",
        icon: UserList,
        isActive: ({ segment, isAffiliateLead }) => segment === "leads" || (segment === "lead-detail" && !isAffiliateLead),
        children: [
            {
                id: "affiliate",
                label: "Affiliate",
                translated: true,
                to: "/affiliate",
                icon: Handshake,
                isActive: ({ segment, isAffiliateLead }) => segment === "affiliate" ||
                    (segment === "lead-detail" && isAffiliateLead),
            },
            {
                id: "objects",
                label: "Objects",
                translated: true,
                to: "/objects",
                icon: Buildings,
                module: Modules.Objects,
                isActive: ({ segment }) => segment === "objects",
            },
            {
                id: "contacts",
                label: "Contacts",
                translated: true,
                to: "/contacts",
                icon: AddressBook,
                module: Modules.Contacts,
                isActive: ({ segment }) => segment === "contacts",
            },
        ],
    },
    {
        id: "workpreparation",
        label: "WorkPreparation",
        translated: true,
        to: "/workpreparation",
        icon: Files,
        isActive: ({ segment }) => segment === "workpreparation" || segment === "workpreparation-details",
    },
    {
        id: "management",
        // Literal, exactly as before — this one was never run through i18next.
        label: "Beheer",
        icon: GearSix,
        isActive: () => false,
        children: [
            {
                id: "users",
                label: "Users",
                translated: true,
                to: "/users",
                icon: Users,
                isActive: ({ segment }) => segment === "users",
            },
            {
                id: "roles",
                label: "RoleManagement",
                translated: true,
                to: "/roles",
                icon: ShieldCheck,
                isActive: ({ segment }) => segment === "roles",
            },
            {
                id: "company-roles",
                label: "Companyroles",
                translated: true,
                to: "/company-roles",
                icon: IdentificationBadge,
                isActive: ({ segment }) => segment === "company-roles",
            },
            {
                id: "origins",
                label: "Origins",
                translated: true,
                to: "/origins",
                icon: Flag,
                isActive: ({ segment }) => segment === "origins",
            },
            {
                id: "object-status",
                label: "ObjectStatus",
                translated: true,
                to: "/object-status",
                icon: ListChecks,
                isActive: ({ segment }) => segment === "object-status",
            },
            // Item #9. Permission-gated, unlike its neighbours in this group, because it can
            // re-point revenue between agents — hiding it is UX, not a security control
            // (the endpoints enforce the same permission server-side).
            {
                id: "revenue-attribution",
                label: "RevenueAttribution",
                translated: true,
                to: "/revenue-attribution",
                icon: Coins,
                module: Modules.RevenueAttribution,
                isActive: ({ segment }) => segment === "revenue-attribution",
            },
        ],
    },
];
